import { StaticImport } from 'next/dist/shared/lib/get-img-props';
import Image from 'next/image';

import closeIcon from '@/public/icons/closeIcon.svg';

import clsx from 'clsx';

type BannerProps = {
  testId: string;
  icon?: string | StaticImport;
  className?: string;
  description: string;
  title?: string;
  onClose?: () => void;
};

export default function Banner({
  testId,
  icon,
  description,
  title,
  className,
  onClose,
}: BannerProps) {
  return (
    <div
      data-testid={`${testId}-banner`}
      className={clsx(
        'rounded-lg p-2 bg-[#E4EDEC80] flex text-sm py-3 px-5 gap-5 items-center',
        className
      )}
    >
      {icon && (
        <Image
          src={icon}
          alt={`${testId} icon`}
          aria-hidden="true"
          data-testid={`${testId}-banner-icon`}
        />
      )}

      <div className="w-full">
        <div className="flex justify-between gap-2">
          {title && (
            <p className="font-bold" data-testid={`${testId}-banner-title`}>
              {title}
            </p>
          )}
          {onClose && (
            <button
              className="flex-shrink-0 w-3 h-3 cursor-pointer"
              type="button"
              aria-label="close banner"
              onClick={onClose}
            >
              <Image src={closeIcon} alt="close-icon" aria-hidden="true" />
            </button>
          )}
        </div>

        <p data-testid={`${testId}-banner-description`}>{description}</p>
      </div>
    </div>
  );
}
